import { useMemo } from "react";
import { ConditionalStyles } from "react-data-table-component";

export const useStaggeredRowStyles = <T>(
  animate: boolean,
  baseDelay = 0.1
): ConditionalStyles<T & { _rowClass: string }>[] => {
  return useMemo(
    () => [
      {
        when: () => animate,
        style: (row: T & { _rowClass: string }) => {
          const delayMatch = row._rowClass.match(/row-delay-(\d+)/);
          const delay = delayMatch ? Number(delayMatch[1]) * baseDelay : 0;
          return {
            opacity: 0,
            transform: "translateY(100px)",
            animation: `fadeInUp 0.4s ease forwards`,
            animationDelay: `${delay}s`,
          };
        },
      },
    ],
    [animate, baseDelay]
  );
};
